import React from 'react';
import { Redirect } from 'react-router-dom';
import { login } from 'adminRoutes';

const Home = () => {
  return <Redirect to={login} />;
};

export default Home;
